import Calendar from "./CalendarEnergy";
import { TabProps } from "src/types/dashboardTypes";
import { Box, styled } from "@mui/material";
import Zone from "./Zone";
import { EnergyIcon } from "src/assets/icons";
import { Colors } from "src/system/constants";

const Energy: React.FC<TabProps> = (props: TabProps) => {
  
  return (
    <Box>
      <EnergyBlockStyled>
        <Zone
          tab={props.tab}
          setTab={props.setTab}
          name="Energy source"
          image={<EnergyIcon />}
          type="energy"
        />
        <Calendar date={props.date} setDate={props.setDate} />
      </EnergyBlockStyled>
    </Box>
  );
};

const EnergyBlockStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  ".Humidity__block": { display: "flex" },
  ".Humidity__block1": { display: "flex", justifyContent: "space-between" },
  ".Humidity__bottom": { display: "flex", justifyContent: "flex-end" },
  ".Humidity__bottom-temperature": {
    fontSize: "20px",
    lineHeight: "23px",
    color: Colors.dimGray,
    padding: "23px 0 0 0",
  },
  ".Humidity__bottom-temperature span": {
    color: Colors.silver,
    display: "inline-block",
    padding: "0 4px 0 4px",
  },
  ".Humidity__bottom-data": {
    fontSize: "20px",
    lineHeight: "23px",
    color: Colors.dimGray,
    padding: "23px 0 0 0",
  },
  ".Humidity__bottom-data span": {
    color: Colors.silver,
    display: "inline-block",
    padding: "0 4px 0 4px",
  },
}));

export default Energy;
